import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import PhoneNumber from "../components/app/PhoneNumber";

export const Signin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [userCountry, setUserCountry] = useState("");
  const [details, setDetails] = useState({
    mobile: "",
    password: "",
  });
  function getMobile(dialCode: string, mobile: string) {
    setUserCountry(dialCode);
    setDetails({ ...details, mobile });
  }
  return (
    <div>
      <div className="md:grid grid-cols-2">
        <div className="hidden md:block">
          <div className="bg-primary min-h-screen w-[50%] fixed h-full"></div>
        </div>
        <div className="flex items-center relative h-screen">
          <div className="max-md:mx-6 md:max-w-[60%] w-full mx-auto">
            <div className="md:text-center">
              <h1 className="font-semibold text-[32px] mb-2">Welcome Back</h1>
              <p className="secondary-text">
                Welcome Back! Please enter your details
              </p>
            </div>
            <div className="my-10">
              <form action="" className="space-y-7">
                <div>
                  <PhoneNumber returnValues={getMobile} />
                </div>
                <div>
                  <label htmlFor="password" className="secondary-text">
                    Password
                  </label>
                  <div className="input-field">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      required
                    />
                    <div onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-themeGray"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5 text-themeGray"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <p className="hover:cursor-pointer text-primary text-right">
                    Forgot Password?
                  </p>
                </div>
                <div className="rounded-lg bg-primary h-[45px]">
                  <Link to="/dashboard">
                    <button type="submit" className="w-full font-medium">
                      Log In
                    </button>
                  </Link>
                </div>
              </form>
            </div>

            <div className="absolute bottom-8">
              <h2 className="secondary-text flex items-center justify-center">
                Don't have an account?{" "}
                <Link
                  to="/login"
                  className="text-primary font-semibold hover:cursor-pointer"
                >
                  <p>Sign Up</p>
                </Link>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
